import { inject, Injectable } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

import { AuthStatus, UserState } from '@app/auth/user.state';
import { EnvironmentService } from '@app/shared/environment.service';
import { XsrfService } from '@app/shared/xsrf.service';

@Injectable({
  providedIn: 'root',
})
export class AppGuard {
  private environmentService = inject(EnvironmentService);
  private router = inject(Router);
  private userState = inject(UserState);
  private xsrfService = inject(XsrfService);
  private userStatus$ = toObservable(this.userState.authStatus);

  canActivate(): UrlTree | boolean | Promise<UrlTree | boolean> | Observable<UrlTree | boolean> {
    if (!this.userState.user()) {
      this.userState.refreshCurrentUser$.next();
    }
    return this.userStatus$.pipe(
      filter((status) => status !== AuthStatus.Pending),
      take(1),
      map((status) => {
        const user = this.userState.user();

        if (status === AuthStatus.Success && user && this.xsrfService.isValidSession()) {
          return true;
        }

        this.userState.updateReturnTo$.next(this.environmentService.currentLocation);

        return this.router.parseUrl('/u/login');
      }),
    );
  }
}
